import { Component } from '@angular/core';

@Component({
  imports: [],
  selector: 'aux-table-skeleton',
  template: `
    <div class="h-[550px] w-full">
      <div class="grid grid-cols-5">
        @for (item of [1, 2, 3, 4, 5]; track item) {
          <div
            class="flex h-[45px] animate-pulse cursor-pointer items-center justify-center border border-aux-gray-dark bg-aux-gray-light font-bold"
          >
            <span class="h-[25px] w-[100px] rounded bg-aux-gray-light-2"></span>
          </div>
        }
      </div>
      <div class="animate-pulse">
        @for (item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track item) {
          <div class="my-1 h-[45px] w-full bg-aux-gray-light-2"></div>
        }
      </div>
    </div>
  `,
})
export class TableSkeletonComponent {}
